import { render } from "./Auth.vue?vue&type=template&id=71546350"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"

import exportComponent from "/home/harlan/sites/kintell-env/api/packages/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Auth.vue"]])

export default __exports__